import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Route } from "react-router-dom";
import { paths } from "utils/constants";
import {
  gotoUrl,
  isMultiLineEligible,
  pathWithChannel,
  urlParam
} from "utils/helpers";
import {
  makeSelectIsUserLoggedIn,
  makeSelectEligibilitySettings,
  makeSelectAuthToken,
  makeSelectAllUserOrders
} from "ducks/selectors";
import useFetchOrder from "hooks/useFetchOrder";
import find from "lodash/find";
import head from "lodash/head";
import Spinner, { styles } from "components/Spinner";
import { ORDER_STATUS, USE_PAYMENT_CARD_PATH } from "utils/constants";
import { get, isEmpty } from "lodash";
import useAuthTokenFromUrl from "hooks/useAuthTokenFromUrl";

const EligibilityRoute = ({ orderAutorized, activeSIMOrder, ...props }) => {
  const isLoggedIn = useSelector(makeSelectIsUserLoggedIn());
  const eligibilitySettings = useSelector(makeSelectEligibilitySettings());
  const { order: orderList, loading } = useFetchOrder(isLoggedIn);
  const authToken = useSelector(makeSelectAuthToken());
  const allOrders = useSelector(makeSelectAllUserOrders());
  const requestPath = window.location.pathname || "/";
  const validateTokenAndAllowAccess = useAuthTokenFromUrl(requestPath);
  const authTokenFromURl = urlParam("auth_token");

  useEffect(() => {
    if (!isEmpty(allOrders) && !isMultiLineEligible(allOrders)) {
      redirectToMyOrders();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, allOrders]);

  const activeOrder = find(
    orderList,
    order =>
      order?.state === ORDER_STATUS.APG || order?.state === ORDER_STATUS.IC
  );

  const redirectToMyOrders = () => {
    gotoUrl(paths.MY_ORDERS, true, {}, true);
  };

  if (authTokenFromURl && authTokenFromURl !== authToken) {
    validateTokenAndAllowAccess(authTokenFromURl);
    return null;
  }

  if (isLoggedIn && !loading && !isEmpty(eligibilitySettings)) {
    if (head(activeOrder)?.order_ref) {
      gotoUrl(
        pathWithChannel(
          USE_PAYMENT_CARD_PATH ? paths.PAYMENT_CARD : paths.PAYMENT,
          "web"
        ),
        false,
        { order_ref: activeOrder[0]?.order_ref },
        false
      );
    } else if (get(eligibilitySettings, "sim_only_order.eligible")) {
      return <Route {...props} />;
    } else if (isMultiLineEligible(orderList)) {
      return <Route {...props} />;
    } else {
      redirectToMyOrders();
    }
  } else if (!loading) {
    return <Route {...props} />;
  } else {
    return <Spinner size={200} sx={styles.fullPage} />;
  }
  return <Spinner size={200} sx={styles.fullPage} />;
};

export default EligibilityRoute;
